// Source unique de verite pour les slugs de service.
// Utilisee a la fois par l'app (seo.ts, composants) et par la config de build
// (vue.config.js : pre-rendu + sitemap), pour garantir que les URLs generees
// correspondent exactement a celles que le routeur tente de resoudre.

function serviceSlug (input) {
  return String(input)
    .normalize('NFD') // separe chaque accent de sa lettre
    .replace(/[̀-ͯ]/g, '') // retire les accents (diacritiques)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-') // tout caractere non alphanumerique -> tiret
    .replace(/^-+|-+$/g, '') // pas de tiret en debut/fin
}

module.exports = { serviceSlug }
